/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import {
    HSAUnit,
    HSAUnitFromJSON,
    HSAUnitToJSON,
} from '../models';

export interface SearchHsaUnitsRequest {
    searchString: string;
}

/**
 * 
 */
export class HSAApi extends runtime.BaseAPI {

    /**
     */
    async getLastSuccessfulImportRaw(initOverrides?: RequestInit): Promise<runtime.ApiResponse<Date>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/api/efrikort/client/hsa/units/last-import`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.TextApiResponse(response) as any;
    }

    /**
     */
    async getLastSuccessfulImport(initOverrides?: RequestInit): Promise<Date> {
        const response = await this.getLastSuccessfulImportRaw(initOverrides);
        return await response.value();
    }

    /**
     */
    async saveHsaUnitsRaw(initOverrides?: RequestInit): Promise<runtime.ApiResponse<void>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/api/efrikort/client/hsa/units/`,
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async saveHsaUnits(initOverrides?: RequestInit): Promise<void> {
        await this.saveHsaUnitsRaw(initOverrides);
    }

    /**
     */
    async searchHsaUnitsRaw(requestParameters: SearchHsaUnitsRequest, initOverrides?: RequestInit): Promise<runtime.ApiResponse<Array<HSAUnit>>> {
        if (requestParameters.searchString === null || requestParameters.searchString === undefined) {
            throw new runtime.RequiredError('searchString','Required parameter requestParameters.searchString was null or undefined when calling searchHsaUnits.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/api/efrikort/client/hsa/units/{searchString}`.replace(`{${"searchString"}}`, encodeURIComponent(String(requestParameters.searchString))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(HSAUnitFromJSON));
    }

    /**
     */
    async searchHsaUnits(searchString: string, initOverrides?: RequestInit): Promise<Array<HSAUnit>> {
        const response = await this.searchHsaUnitsRaw({ searchString: searchString }, initOverrides);
        return await response.value();
    }

}
